import {
  AccessMemberGroupValue,
  recipientsAreSame,
  Value as RecipientsSelectorValue,
} from 'components/ShareSheet/RecipientSelector/Types'
import {
  InformalFeedbackReviewChannelReviewer,
  InformalFeedbackReviewEmailReviewer,
  InformalFeedbackReviewReviewer,
} from '../../../api/clients/InformalFeedbackRequestsClient'
import { RecipientsSelectorValueType } from 'types'
import { Dispatch } from 'react'

export const splitByType = (
  selectedValues: RecipientsSelectorValue[],
  requiredValues: RecipientsSelectorValue[] = [],
) => {
  const users: InformalFeedbackReviewReviewer[] = []
  const channels: InformalFeedbackReviewChannelReviewer[] = []
  const emails: InformalFeedbackReviewEmailReviewer[] = []

  for (const selectedValue of selectedValues) {
    const isRequired = requiredValues.includes(selectedValue)
    switch (selectedValue.type) {
      case RecipientsSelectorValueType.AccessMemberGroup:
        const group = selectedValue as AccessMemberGroupValue
        group.value.members.forEach((member) => users.push({ id: member.id, required: isRequired }))
        group.value.channels.forEach((channel) => channels.push({ id: channel.id, required: isRequired }))
        break
      case RecipientsSelectorValueType.User:
        users.push({ id: selectedValue.value.id, required: isRequired })
        break
      case RecipientsSelectorValueType.Channel:
        channels.push({ id: selectedValue.value.id, required: isRequired })
        break
      case RecipientsSelectorValueType.Email:
        emails.push({
          email: selectedValue.value,
          required: isRequired,
        })
        break
    }
  }
  return { users, channels, emails }
}

export const synchronizeRolesIn = (
  roles: RecipientsSelectorValue[][],
  roleSetters: Dispatch<RecipientsSelectorValue[]>[],
) => {
  const updatedArray = roles[0]
  const setUpdatedArray = roleSetters[0]
  setUpdatedArray(updatedArray)
  for (let i = 1; i < roles.length; i++) {
    const otherArray = roles[i]
    const setOtherArray = roleSetters[i]
    setOtherArray(
      otherArray.filter((otherRole) => {
        // Remove user from other roles if present in updated array
        return !updatedArray.some((updated) => recipientsAreSame(updated, otherRole))
      }),
    )
  }
}
